import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    wrapper:
      'bg-bg-page xs:max-w-[380px] flex max-w-[320px] min-w-[320px] flex-col p-10 md:max-w-none',
    actionButtonWrapper: 'mt-auto',
    actionButton:
      'heading-s-intr-bold mt-6 cursor-pointer tracking-wider uppercase'
  }
});
